import React from "react";
import { Link } from "react-router-dom";

const STORY = "/lifestyle/lifestyle_story.png";
const PORTRAIT = "/lifestyle/lifestyle_hero.png";

export default function OurStory() {
  return (
    <div data-testid="our-story-page" className="bg-poche-black text-white">
      <section className="container-x pt-20 pb-12 grid grid-cols-1 md:grid-cols-12 gap-10 items-end">
        <div className="md:col-span-7">
          <p className="text-[11px] tracking-luxury uppercase text-poche-gold">The House of Joseph Poche</p>
          <h1 className="font-serif text-6xl md:text-8xl mt-4 leading-[0.92]">
            From a single<br />
            <span className="italic text-poche-gold">observation.</span>
          </h1>
        </div>
        <div className="md:col-span-5">
          <p className="text-white/70 leading-relaxed text-lg">
            The world's most celebrated luxury eyewear was never built for the world's most overlooked faces.
            Joseph Poche began with one question — and a refusal to accept the answer.
          </p>
        </div>
      </section>

      <section className="grid grid-cols-1 md:grid-cols-2 gap-px bg-poche-gold/10">
        <div className="relative aspect-[4/5] bg-poche-ink">
          <img src={STORY} alt="" className="absolute inset-0 w-full h-full object-cover grayscale" />
        </div>
        <div className="bg-poche-black p-10 md:p-16 flex flex-col justify-center">
          <p className="text-[11px] tracking-luxury uppercase text-poche-gold">Chapter I · The Bridge</p>
          <h2 className="font-serif text-4xl md:text-5xl mt-4 leading-tight">Designed from the bridge outward.</h2>
          <p className="text-white/65 leading-relaxed mt-6">
            Joseph Poche begins where the rest of the eyewear industry stops — at the bridge.
            Wider, deeper, more architectural. Frames designed not to fit a single archetype, but to hold the
            contour, weight, and presence of real faces — African, global, sculpted, alive.
          </p>
        </div>
      </section>

      <section className="grid grid-cols-1 md:grid-cols-2 gap-px bg-poche-gold/10">
        <div className="bg-poche-black p-10 md:p-16 flex flex-col justify-center order-2 md:order-1">
          <p className="text-[11px] tracking-luxury uppercase text-poche-gold">Chapter II · The House</p>
          <h2 className="font-serif text-4xl md:text-5xl mt-4 leading-tight">From Lagos.<br />To the diaspora.<br />To the world.</h2>
          <p className="text-white/65 leading-relaxed mt-6">
            We design in Lagos. We craft in Italy. Our Legacy Edition is born in Switzerland.
            Every Joseph Poche piece moves through three continents before it reaches your hands — but the story
            always begins in West Africa, with a contour the rest of the industry forgot to see.
          </p>
        </div>
        <div className="relative aspect-[4/5] bg-poche-ink order-1 md:order-2">
          <img src={PORTRAIT} alt="" className="absolute inset-0 w-full h-full object-cover" />
        </div>
      </section>

      <section className="container-x py-24 text-center">
        <p className="text-[11px] tracking-luxury uppercase text-poche-gold">The Joseph Poche Promise</p>
        <h2 className="font-serif text-4xl md:text-6xl mt-4 max-w-4xl mx-auto leading-tight">
          We design for those whose faces have always built the world.
          <span className="block italic text-poche-gold mt-3">Quietly. Confidently. Without compromise.</span>
        </h2>
        <Link to="/shop" className="btn-outline-gold mt-10 inline-flex">Enter the House</Link>
      </section>
    </div>
  );
}
